module.exports = {
	"base": {
		"welcome": "Us donem la benvinguda a Mulligans, %{name}.",
		"user": "Informació de l'usuari",
		"devices": "Dispositius",
		"refunds": "Reemborsaments",
		"resources": "Recursos",
		"transactions": "Comandes i devolucions",
		"email": "Correu electrònic",
		"password": "Contrasenya",
		"save": "Desa",
		"sign-out": "Tanca la sessió",
		"cancel": "Cancel•la",
		"close": "Tanca",
		"learn-more": "Més informació",
		"required": "Necessari",
		"support": "Assistència",
		"bookshelf": "Bookshelf",
		"launch": "Inicia",
		"download": "Baixa",
		"details": "Dades",
		"cannot-be-blank": "%{field} no pot estar buit.",
		"saving": "S'està desant…",
		"done": "Fet",
		"failed": "Error",
		"copy": "Copia"
	},
	"signin": {
		"login-failure": "Correu electrònic o contrasenya incorrectes",
		"welcome-large": "Us donem la benvinguda al <span class='inner'>Account Center de %{brand}</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Inicia la sessió",
		"forgot-password": "Heu oblidat la contrasenya?",
		"new-to-vst": "Nou a %{brand}?",
		"create-account": "Creeu un compte",
		"signing-in": "Iniciant la sessió...",
		"signin-failed": "Error d'inici de sessió"
	},
	"transactions": {
		"price": "Preu",
		"excluded": "(impost no inclòs)",
		"quantity": "Quantitat",
		"confirmation#": "Núm. de confirmació",
		"payment": "Pagament",
		"purchased": "Comprats",
		"purchase-details": "Dades de la compra",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Impost",
		"loading": "Ei, malgastador, estem carregant les teves transaccions...",
		"no-purchases": "No tens cap compra.",
		"seller-vat": "IVA del venedor",
		"total-vat": "%{vat} total pagat",
		"portion": "%{subTax} Impost %{rate}%",
		"vat-disclosure": "El preu inclou %{vat}",
		"purchases": "Compres",
		"refunded-items": "Articles reembossats",
		"book-title": "Títol del llibre",
		"refund-details": "Dades del reemborsament",
		"print-receipt": "Imprimeix el rebut",
		"request-refund": "Sol·licita el reembossament",
		"expired": "Ha caducat",
		"expires-in": "Caduca el %{date}",
		"details-refund": "Detalls i reemborsament",
		"modal": {
			"cant-refund-title": "Reemborsament no disponible",
			"cant-refund": "El teu llibre no es pot reembossar per alguna o diverses raons.",
			"cant-refund-1": "S'ha vist una part considerable del teu llibre.",
			"cant-refund-2": "Han passat més de 14 dies des de la data de compra.",
			"cant-refund-3": "S'ha mostrat el teu codi de recursos en línia.",
			"cant-refund-4": "El teu llibre ha estat reembossat prèviament.",
			"cant-refund-5": "Tots els codis ja s'han bescanviat o reembossat.",
			"cant-refund-6": "Han passat més de 30 dies des de la data de compra.",
			"cant-refund-support": "Si encara teniu dubtes sobre la política de reembossaments de %{brand}, poseu-vos en contacte amb <a href='%{support_url}' target='_blank'>el servei d'assistència</a>."
		},
		"license": {
			"perpetual": "L'accés en línia no caduca",
			"days": "Accés per %{days}"
		}
	},
	"devices": {
		"description": "%{brand} us permet tenir <span>%{desktop}</span> ordinadors i <span>%{mobile}</span> dispositius mòbils i tauletes activats en tot moment.",
		"loading": "Ei tu, estem obtenint els teus dispositius :)",
		"no-active": "No tens cap dispositiu actiu.",
		"deactivate": "Desactiva"
	},
	"user": {
		"personal-information": "Dades personals",
		"security-information": "Informació de seguretat",
		"notifications": "Notificacions",
		"first-name": "Nom",
		"last-name": "Cognom",
		"change-password-title": "Canvia la contrasenya",
		"current-password": "Contrasenya actual",
		"new-password": "Nova contrasenya",
		"security-password": "Contrasenya",
		"confirm-new-password": "Confirma la nova contrasenya",
		"security-question": "Pregunta de seguretat",
		"security-info-change": "Canvia",
		"question": "Pregunta",
		"answer": "Resposta",
		"notifications-text": "Envieu-me per correu electrònic de tant en tant actualitzacions sobre l'activitat del meu compte, novetats de productes i ofertes especials.",
		"loading": "Llampec està treient les teves dades d'usuari, espera un segon 🐶",
		"change-password-text": "La contrasenya ha de tenir vuit caràcters com a mínim, una lletra en majúscules, una lletra en minúscules i un caràcter especial.",
		"email-locked": "Correu electrònic bloquejat",
		"email-locked-description": "No teniu permís per canviar el vostre correu electrònic.",
		"email-locked-more": "Poseu-vos en contacte amb el vostre administrador.",
		"security-question6": "Quin és el vostre esport preferit?",
		"security-question7": "Quin és el vostre gust de gelat preferit?",
		"security-question8": "Quin és el vostre nom preferit per a un animal de companyia?",
		"security-question9": "Quan éreu jove, què volieu ser quan fóssiu gran?",
		"security-question10": "Quin era el cognom del vostre mestre preferit?",
		"new-password-failure": "La contrasenya no compleix els requisits",
		"confirm-password-failure": "La contrasenya ha de coincidir",
		"new-password-tooltip": "Ha de tenir 8 o més caràcters, una lletra en majúscules, una lletra en minúscules i un caràcter especial.",
		"enter-valid-email": "Introduïu un correu electrònic vàlid.",
		"password-cannot-be-same": "La contrasenya no pot coincidir amb la contrasenya antiga",
		"incorrect-password": "Contrasenya incorrecta",
		"complete-account": "Pel que sembla, encara no heu <a href='%{href}'>completat el vostre compte</a>.",
		"completing-allows": "Completar el vostre compte us permet llegir llibres fora de línia en les nostres aplicacions per al mòbil, a m´és de compartir notes i elements realçats amb els amics.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Complements",
		"access-codes": "Codis d'accés",
		"print-on-demand": "Impressió sota demanda",
		"check-pod": "Comproveu les opcions d'impressió de l'editor pels vostres llibres.",
		"check-now": "Comprova-ho ara",
		"loading": "No marxis, estem actualitzant els teus recursos!",
		"in": "en",
		"access-code-intro": "Un codi d'accés és una contrasenya que utilitzeu per accedir al contingut del curs en línia. Un cop mostrat el codi d'un element, ja no el podreu retornar. Per a obtenir més instruccions sobre com usar els vostres codis d'accés, visiteu <a href='%{support_url}' target='_blank'>el servei d'assistència</a>.",
		"expires": "Caduca",
		"expiration-message": "Conté instruccions per a utilitzar el vostre codi d'accés.",
		"copy-fail": "No es pot copiar. Seleccioneu el codi i copieu-lo manualment.",
		"launch-site": "Inicia el lloc",
		"launch-book": "Inicia el llibre",
		"reveal-code": "Mostra el codi",
		"no-resources": "No tens cap recurs.",
		"no-access-codes": "No tens cap codi d'accés.",
		"no-ancillaries": "Aquest títol no té cap complement",
		"name": "Nom",
		"type": "Tipus",
		"size": "Mida",
		"download-all": "Baixa tot",
		"back": "Torna als recursos"
	},
	"refunds": {
		"states": {
			"refunded": "Reembossat",
			"unavailable": "Reembossament no disponible"
		},
		"reasons": {
			"dropped": "He deixat el curs",
			"wrong": "Aquest no era el llibre correcte pel meu curs",
			"print": "Vaig decidir comprar una versió impresa ",
			"missing": "El llibre no inclou tot el que necessito pel meu curs (per exemple, un CD, accés web, videos)",
			"other": "Altres"
		},
		"bulk": {
			"policy": "En fer clic al botó &quot;Completa el reembossament&quot;, a sota, estic acceptant la política de reembossament <a href='%{policy_url}' target='_blank'></a> de %{brand}.",
			"complete": "Completa el reembossament",
			"view-details": "Mostra les dades del reembossament",
			"success": "S'ha sol·licitat el reemborsament. Tardarà 48 hores a processar-se.",
			"failure": "Vaja, alguna cosa no ha anat bé. Malauradament el vostre reembossament no s'ha processat.",
			"retry": "Torneu-ho a provar",
			"support": "Poseu-vos en contacte amb el servei d'assistència",
			"available-codes": "Codis disponibles",
			"codes-selected": "Codis seleccionats",
			"download": "Baixa els codis",
			"partially-refunded": "Reembossats parcialment",
			"pick-one": "Per obtenir un reembossament cal que seleccioneu almenys un codi"
		},
		"refund": "Reembossats",
		"all": "Reembossar tots?",
		"missing-reason": "Cal que seleccioneu una raó per continuar",
		"missing-elaboration": "Podeu donar-nos més detalls?",
		"policy": "En fer clic al botó “Completa la sol·licitud de reembossament” a sota, entenc que si torno a adquirir aquest llibre de text electrònic de %{brand} no tindré dret a sol·licitar cap altre reembossament addicional d'aquest mateix llibre de text electrònic. Veure la política de devolucions completa.",
		"refunded": "Reembossat",
		"sorry": "Lamentem que no estigueu satisfets amb la vostra compra.",
		"error": "Alguna cosa no ha anat bé",
		"error-explain": "No hem pogut processar el vostre reembossament. Torneu-ho a provar.",
		"why": "Diga'ns el perquè",
		"no-refunds": "No tens cap element reembossat.",
		"select-codes": "Seleccioneu el codi o codis que voleu reembossar:",
		"number": "Quants?",
		"back": "Torna als reembossaments"
	},
	"purchases": {
		"back": "Torna a les compres"
	},
	"global-bar": {
		"account": "Configuració del compte"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ca.json
 ** module id = 995
 ** module chunks = 0
 **/